export const api1 = "https://api.izttra.com/morenamia-api-dev/";
export const apigeneral1 = "";
export const x_accesskey1 = "1081592e5bcf4d20a3233e044a0171f4";
export const SecretKey1 = "116971e670ad4dc6821dd3ea75d7f671";